import { axios } from "../../lib/axios";

export const DeleteCartBook = (bookId: string) => {
    return axios.delete(`/cart/removeBookFromCart/${bookId}`)
        .then(response => response.data);
};